
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "0db502d0-5162-4ee9-8c8b-5c6546db8ed9"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/app/base/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
